<div class="action-panel survey-panel">
  <div class="action-panel-header">
    <i class="fa fa-star" style="margin-right:6px;"></i>
    {{ isPssProject ? title : (auth.isProject() ? 'Project feedback' : 'Expert feedback') }}
  </div>

  <div class="action-panel-body">

    <form-error-summary [errors]="fieldErrors" (jumpTo)="jumpToField($event)"></form-error-summary>

    <div *ngFor="let question of questions; let i = index" class="survey-question-wrap">

      <!-- Project survey: section dividers -->
      <ng-container *ngIf="!isPssProject">
        <h5 *ngIf="auth.isProject() && i == 0"  class="survey-section-title">Expert</h5>
        <h5 *ngIf="auth.isProject() && i == 4"  class="survey-section-title">Expert recommendations</h5>
        <h5 *ngIf="auth.isProject() && i == 10" class="survey-section-title">HSbooster support</h5>
        <h5 *ngIf="auth.isProject() && i == 12" class="survey-section-title">Referral</h5>
      </ng-container>
      <!-- PSS project survey: section dividers come from the JSON -->
      <h5 *ngIf="question['section']" class="survey-section-title">{{ question['section'] }}</h5>
      <div *ngIf="question['section_description']" class="survey-section-description" [innerHTML]="question['section_description']"></div>

      <open-question *ngIf="isOpenQuestion(question)"
                     [type]="'survey'"
                     [question]="getQuestionKey(question)"
                     [editor]="getQuestion(question)"
                     [description]="getQuestionDescription(question)"
                     [required]="isFieldRequired(getQuestionKey(question))"
                     [submitted]="submitted">
      </open-question>

      <tick-box *ngIf="!isOpenQuestion(question) && !isDropdown(question)"
                [fields]="question"
                [type]="'survey'"
                [required]="isFieldRequired(getQuestionKey(question))"
                [submitted]="submitted">
      </tick-box>

      <div *ngIf="isDropdown(question) && showModulesSection()" class="survey-modules">
        <h5 class="survey-section-title">Modules accessed</h5>
        <div *ngFor="let level of levels" class="module-level">
          <button type="button" class="template-toggle" (click)="expand(level)">
            {{ level }}
            <i class="fa" [ngClass]="expandedStatus(level) === 'in' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <div *ngIf="expandedStatus(level) === 'in'" class="template-body">
            <tick-box [fields]="getQuestionsByLevel(level)" [type]="'survey'" [required]="false"></tick-box>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="toSubmit" class="survey-submit-row">
      <button (click)="confirm()" class="btn btn-primary action-btn">
        <i class="fa fa-paper-plane"></i> Submit survey
      </button>
    </div>
  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
